









import Vue, { PropType } from 'vue';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-date-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionDateItemStoreNew from '@/store/modules/cvSectionDateItemNew';
import { CvSectionDate } from '@/../gen';
import { DATE_SEPARATOR_IN_FORM } from '@/utils/constants';
import { i18n, i18nHints } from '@/plugins/i18n';
import { splitDate } from '@/utils/date';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionDate>,
      required: true,
    },
  },
  methods: {
    async onSubmit({
      title,
      organization,
      website_url,
      description,
      start_date,
      end_date,
    }: FormDataInterface) {
      const [start_date_year, start_date_month, start_date_day] = splitDate(
        start_date,
        DATE_SEPARATOR_IN_FORM
      );
      const [end_date_year, end_date_month, end_date_day] = splitDate(
        end_date,
        DATE_SEPARATOR_IN_FORM
      );
      await this.$store.dispatch(
        CvSectionDateItemStoreNew.CreateCvSectionDateItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_date_id: this.section.id,
          },
          body: {
            title,
            organization,
            website_url,
            description,
            start_date_year: start_date_year || '',
            start_date_month: start_date_month || '',
            start_date_day: start_date_day || '',
            end_date_year: end_date_year || '',
            end_date_month: end_date_month || '',
            end_date_day: end_date_day || '',
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
